const langlist = {
  確認: '確認画面へ進む',
  telerror: '電話番号を正しくご入力ください。',
  telcharerror: '電話番号は半角数字でハイフンを含めずにご入力ください。',
  tellengtherror: '電話番号は10桁もしくは11桁でご入力ください。',
  mobtellengtherror: '携帯電話番号は11桁でご入力ください。',
  includespace: 'スペース、タブ、改行は含めないで下さい。',
  規約未選択: '上記項目に同意いただく必要があります。',
  支払い説明1: 'お支払い方法は「${text}」のみとなります。下記をご確認のうえ、お進みください。',
  支払い説明2: 'お支払い方法について下記をご確認のうえ、お進みください。',
};

module.exports = langlist;
